import React from 'react';
import { Box } from '@mui/material';
import { getUltraRoomGridContainerSx } from '../../utils/dashboardUltraGridLayout';

/**
 * Room board grid — CSS auto-fill keeps card width stable while the panel resizes
 * (no JS column-count jumps during window or sidebar animation).
 */
export default function UltraRoomGridContainer({
  isDark,
  isMobileLayout = false,
  isWorkspaceLayout = false,
  children,
}) {
  return (
    <Box
      data-ultra-room-grid=""
      sx={getUltraRoomGridContainerSx({
        isDark,
        isMobileLayout,
        isWorkspaceLayout,
      })}
    >
      {children}
    </Box>
  );
}
